
import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { SupervisionRequest } from "@/types/coach";

export const useSupervisionRequests = () => {
  const [supervisionRequests, setSupervisionRequests] = useState<SupervisionRequest[]>([]);
  const { toast } = useToast();

  const fetchSupervisionRequests = useCallback(async (coachId: string) => {
    try {
      const { data: requests, error: requestsError } = await supabase
        .from("supervision_requests")
        .select("*")
        .eq("coach_id", coachId)
        .order("requested_at", { ascending: false });

      if (requestsError) {
        throw requestsError;
      }

      if (!requests || requests.length === 0) {
        setSupervisionRequests([]);
        return;
      }

      const requestsWithProfiles = await Promise.all(
        requests.map(async (request) => {
          try {
            const { data: profile, error: profileError } = await supabase
              .rpc("get_trainee_safe_profile", { trainee_id: request.trainee_user_id });

            if (profileError) {
              console.error("Erreur profil pour request:", request.id, profileError);
            }

            const safeProfile = profile?.[0] || null;
            return {
              ...request,
              profiles: safeProfile ? {
                username: safeProfile.username,
                avatar_url: safeProfile.avatar_url,
                created_at: safeProfile.created_at
              } : { username: "Utilisateur inconnu" }
            };
          } catch (err) {
            console.error("Erreur traitement request:", err);
            return {
              ...request,
              profiles: { username: "Utilisateur inconnu" }
            };
          }
        })
      );

      setSupervisionRequests(requestsWithProfiles);

    } catch (error: any) {
      console.error("Erreur fetchSupervisionRequests:", error);
      toast({
        variant: "destructive",
        title: "Erreur",
        description: "Impossible de charger les demandes de supervision",
      });
    }
  }, [toast]);

  return {
    supervisionRequests,
    fetchSupervisionRequests,
  };
};
